import * as THREE from "three";

// Вершинный шейдер
const vertexShader = `
  varying vec2 vUv;
  
  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

// Фрагментный шейдер для градиентной тени
const fragmentShader = `
  uniform float opacity;
  uniform float softness;
  varying vec2 vUv;
  
  void main() {
    // Вычисляем расстояние от центра (0.5, 0.5)
    vec2 center = vec2(0.5, 0.5);
    float dist = distance(vUv, center);
    
    // Создаем очень мягкий градиент от центра к краям
    float maxDist = 0.5;
    float normalizedDist = dist / maxDist;
    
    // Используем более плавный переход для очень размытой тени
    // Меньше softness = более размытая тень
    float fadeStart = 0.0;
    float fadeEnd = 0.7 * softness; // Увеличиваем область затухания
    
    float alpha = opacity * (1.0 - smoothstep(fadeStart, fadeEnd, normalizedDist));
    
    // Дополнительное сглаживание для устранения белых просветов
    alpha = pow(alpha, 0.8); // Сделаем переход еще более плавным
    
    gl_FragColor = vec4(0.0, 0.0, 0.0, alpha);
  }
`;

class ShadowMaterial extends THREE.ShaderMaterial {
  constructor(opacity = 0.4, softness = 1.5) {
    super({
      vertexShader,
      fragmentShader,
      uniforms: {
        opacity: { value: opacity },
        softness: { value: softness },
      },
      transparent: true,
      depthWrite: false,
    });
  }
}

export { ShadowMaterial };

